import React from "react";

interface DeviceApprovalProps {
  clientName: string;
  scopes: string[];
  onApprove: () => void;
  onDeny: () => void;
  loading: boolean;
  error: string | null;
}

export default function DeviceApproval({
  clientName,
  scopes,
  onApprove,
  onDeny,
  loading,
  error,
}: DeviceApprovalProps) {
  return (
    <div>
      <h1 className="h3 fw-bold text-dark mb-1">Approve this device?</h1>
      <p className="text-muted mb-4">
        <strong>{clientName}</strong> is requesting access to your account.
      </p>

      {scopes.length > 0 && (
        <div className="mb-3">
          <p className="small text-muted mb-2">Requested permissions:</p>
          <ul className="list-unstyled small text-muted">
            {scopes.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
      )}

      {error && (
        <div className="alert alert-danger py-2 mb-3" role="alert">
          {error}
        </div>
      )}

      <div className="d-grid gap-2">
        <button
          type="button"
          className="btn btn-primary btn-lg"
          onClick={onApprove}
          disabled={loading}
        >
          Approve
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-lg"
          onClick={onDeny}
          disabled={loading}
        >
          Deny
        </button>
      </div>
    </div>
  );
}
